<template>
  <div style="margin:20px">
    <FiPageRail title="Vehicle Trip History" />
    <!-- filter bar: wrapping groups, so a phone gets stacked full-width-safe
         controls instead of one overflowing centered line -->
    <div class="map-controls">
      <span class="mc-group">
        <a href="#" class="arrows" v-on:click.prevent="shift_detail_graph_date(-1)"><</a>
        <date-picker class="mc-datepicker" v-model="details_fromDate" :config="options" :placeholder="details_fromDate"></date-picker>
        <a href="#" class="arrows" v-on:click.prevent="shift_detail_graph_date(1)">></a>
      </span>
      <span class="mc-group">
        <span>Select Vehicle:</span>
        <template v-if="vehicle_options.length > 0">
          <b-form-select v-model="vehicle_id" :options="vehicle_options" class="mc-select mc-select--vehicle"/>
          <b-button v-on:click.prevent="load_data()">Search</b-button>
        </template>
        <b-spinner v-else style="width: 1.5rem; height: 1.5rem;" label="Loading..."></b-spinner>
      </span>
      <span class="mc-group">
        <span>Ignition Events:</span><b-checkbox size="lg" v-model="show_ignition_events"></b-checkbox>
        <span>Labels:</span><b-checkbox size="lg" v-model="show_geofence_names"></b-checkbox>
      </span>
    </div>

    <br/>
    <div v-if="!loading">
      <div v-if="items.length > 0" ref="test" class="row" style="margin: 0px">
        <div class="col" style="overflow-y:scroll; max-height: 900px; max-width: 450px">
          <div style="font-weight: bold; font-size: 20px; color: var(--fi-rail-accent); margin: 5px;">Vehicle {{vehicle_id}} - {{summary.result_date}}</div>
          <div style="font-weight: bold; font-size: 20px; color: var(--fi-rail-accent); margin: 5px;">{{summary.trip_cnt}} Trips, {{summary.total_trip_distance}} Miles</div>
          <div v-if="summary && summary.booking_id"  style="text-align: left; padding:8px; border-top: 1px solid black;">
            <b>Current Booking: <router-link style="font-weight: bold;" :to="{ path: '/actuals?booking_id=' + summary.booking_hash }">{{ summary.booking_id }}</router-link></b>
            <br/>
            <b>Start:</b> {{summary.booking_start_time | formatDateTimeSmall}}<br/>
            <span v-if="summary.booking_pickup_time">
              <b>Pickup:</b> {{summary.booking_pickup_time | formatDateTimeSmall}}<br/>
            </span>
            <span v-if="summary.booking_arrival_time">
              <b>Arrival:</b> {{summary.booking_arrival_time | formatDateTimeSmall}}<br/>
            </span>
            <span v-if="summary.booking_back_time">
              <b>Back:</b> {{summary.booking_back_time | formatDateTimeSmall}}
              <br/>
            </span>
            <span v-if="summary.booking_finish_time">
              <b>Finish:</b> {{summary.booking_finish_time | formatDateTimeSmall}}
              <br/>
            </span>
          </div>

          <div v-if="items"  style="text-align: left; padding:8px; border-top: 1px solid black;">
            <span @click="openInfoWindowTemplate(items[0].name)"><b>Earliest:</b>  {{items[0].time | formatDateTimeSmall}}</span>
            <br/>
            <span @click="openInfoWindowTemplate(items[items.length - 1].name)"><b>Latest:</b> {{items[items.length - 1].time | formatDateTimeSmall}}</span>
          </div>

          <div v-if="show_ignition_events || trip.type != 'state'" class="trip-item" v-for="trip in trips" :style="trip.selected ? 'background-color: lightgrey': ''" style="text-align: left; padding:6px; border-top: 1px solid var(--fi-rail-accent);">
            <div @click="toggle_trip(trip)" >
              <span v-if="trip.type == 'state'">
                <span v-if="show_ignition_events">
                  <span v-if="trip.startAddress" style="font-size: 15px; font-weight: bold;">{{trip.startAddress.name | trim(18)}}</span>
                  <span @click="openInfoWindowTemplate(trip.startMs)" style="float:right; font-size: 15px; font-weight: bold;">
                    {{trip.state.toUpperCase()}} ({{trip.duration}})&nbsp;&nbsp; {{trip.startTime | formatDateTimeSmall}}
                  </span>
                  <br/>
                </span>
              </span>
              <span v-else>
                <span v-if="trip.startAddress" style="color: green; font-size: 16px; font-weight: bold;">{{trip.startAddress.name | trim(30)}}</span>
                <span v-else style="color: green; font-size: 16px; font-weight: bold">{{trip.startLocation | trim(25)}}</span>
                <span @click="openInfoWindowTemplate(trip.startMs)" style="float:right; font-size: 16px; font-weight: bold;">{{trip.startTime}}</span>
                <br/>
                <span v-if="trip.endAddress" style="color: darkred; font-size: 16px; font-weight: bold;">{{trip.endAddress.name  | trim(30)}}</span>
                <span v-else style="color: darkred; font-size: 16px; font-weight: bold;">{{trip.endLocation | trim(25)}}</span>
                <span @click="openInfoWindowTemplate(trip.endMs)" v-if="trip.endTime" style="float:right; font-size: 16px; font-weight: bold;">{{trip.endTime}}</span>
                <br/>
                <span v-if="trip.driver" style="color: grey; font-size: 16px;">{{trip.driver}}</span>
                <span v-if="trip.duration" style="float:right; font-size: 16px;font-weight: bold;">({{trip.duration}})</span>
                <span v-if="trip.distanceMiles" style="float:right; font-size: 16px;font-weight: bold;">{{trip.distanceMiles}} mi&nbsp;</span>
                <span v-if="trip.startOdometer" style="float:right; font-size: 16px;font-weight: bold;">odo: {{trip.startOdometer}} &#8594; {{trip.endOdometer}}&nbsp;|&nbsp;</span>
                <br/>
              </span>

            </div>
          </div>
        </div>
        <div class="col" style="border: none; padding-right:0px !important; padding-left:0px !important">
          <GmapMap id="map" ref="mapRef"
                   :zoom="zoom"
                   :center="center"
                   :options="themed_map_options"
                   style="width:100%;  height: 900px;"
          >
            <GmapMarker
                v-for="(marker,idx) in markers"
                :key="idx"
                :position="marker.position"
                :label="marker.label"
                :draggable="false"
                :clickable="true"
                :icon="marker.icon"
                @mouseover="openInfoWindowTemplate(marker.title)"
                @mouseout="infoWindow.open=false"
            />
            <GmapInfoWindow
                :options="{
                              pixelOffset: { width: 0, height: -15 }
                            }"
                :position="infoWindow.position"
                :opened="infoWindow.open"
            >
              <div v-html="infoWindow.template"></div>
            </GmapInfoWindow>

          </GmapMap>
        </div>
      </div>
      <div v-else-if="items.length === 0 && vehicle_id" style="font-weight: bold; font-size: 24px"><br/><br/>no trip data found for vehicle {{vehicle_id}} on {{details_fromDate}}</div>
    </div>
    <div v-if="loading">
      <br/><br/>
      <b-spinner style="width: 3rem; height: 3rem;" label="Loading..."></b-spinner>
    </div>
  </div>
</template>
<script>
import {get_vehicle_trip_history,get_vehicle_list} from '../networking/apis'
import {justDate} from "../helpers/dates";
import moment from "moment";
import {mapState} from "vuex";
import {gmapApi} from "vue2-google-maps";
import {get_tbn_vehicle_trip_history} from "../networking/tbn_apis";
import {DARK_MAP_STYLES} from "../assets/dark_map_styles";

export default {
  name: 'vehicle_trip_history',
  components: {},
  metaInfo: {
    title: "Fleet Integrations",
    titleTemplate: "Fleet Integrations",
  },
  data() {
    return {
      selected_trip: null,
      details_fromDate: justDate(moment()),
      items: [],
      vehicle_id: null,
      vehicle_options: [],
      trips: [],
      addresses: [],
      loading: false,
      show_geofence_names: false,
      show_ignition_events: false,
      center: null,
      zoom: null,
      markers: [],
      markers_full: [],
      _zoomListener: null,
      infoWindow: {
        position: {lat: 0, lng: 0},
        open: false,
        template: ''
      },
      options: {
        format: 'MM-DD-YYYY',
        useCurrent: true,
        minDate: moment().subtract(180, 'days'),
        maxDate: moment().add(0, 'days'),
        keepOpen: false,
        showClear: true,
        showClose: true,
        toolbarPlacement: 'top',
      },
      mapStyle: {
        styles: [
          {
            "featureType": "landscape",
            "stylers": [
              {"color": "#F3F4F9"}
            ]
          }, {
            "featureType": "water",
            "stylers": [
              {"color": "#C1CDE4"}
            ]
          },
          {
            "featureType": "landscape.natural.terrain",
            "stylers": [
              {"color": "#E0EDCA"}
            ]
          },
          {
            featureType: 'road',
            elementType: 'geometry.stroke',
            stylers: [{color: '#DDDDDD'}]
          },
          {
            featureType: 'road',
            elementType: 'geometry.fill',
            stylers: [{color: '#FFFFFF'}]
          },
          {
            featureType: 'road.highway',
            elementType: 'geometry.fill',
            stylers: [{color: '#FEF8D6'}]
          },
          {
            featureType: 'transit',
            stylers: [{"visibility": "off"}]
          },
          {
            featureType: 'poi',
            stylers: [{"visibility": "off"}]
          },
        ]
      }
    }
  },
  async created() {
    await this.check_features()
  },
  methods: {
    toggle_div(item,field) {
      item[field] = !item[field];
      this.$forceUpdate();
    },
    async shift_detail_graph_date(shift) {
      this.details_fromDate = moment(this.details_fromDate, 'MM-DD-YYYY').add(shift, 'days').format('MM-DD-YYYY');
      this.details_toDate = moment(this.details_toDate, 'MM-DD-YYYY').add(shift, 'days').format('MM-DD-YYYY');
    },
    async check_features() {
      this.load_vehicles()

      if (this.$route.query.trip_date) {
        this.details_fromDate = moment(this.$route.query.trip_date,'YYYY-MM-DD').format('MM-DD-YYYY')
      }
      
      if (this.$route.query.vehicleId) {
        this.vehicle_id = this.$route.query.vehicleId
        this.load_data()
      }
    },
    openInfoWindowTemplate(selected_name) {
      let loc = this.items.filter(item => item.name == selected_name)[0]

      if (loc == null) {
        loc = this.items.filter(item => item.timeMs == selected_name)[0]
      }

      if (loc != null) {
        const position = {
          lat: Number(loc.lat),
          lng: Number(loc.lng),
        };
        this.infoWindow.position = position
        this.infoWindow.template = loc.marker_html
        this.infoWindow.open = true
        this.zoom = 12;
      }
    },
    toggle_trip(trip) {
      trip['selected'] = !trip['selected'];

      for (const currtrip of this.trips) {
        if (currtrip.startMs != trip.startMs)
          currtrip['selected'] = false
      }

      this.$forceUpdate();

      if (trip['selected']) {
        this.selected_trip = trip

        let tmp_markers = [];
        let cnt = 0;
        for (const loc of this.items) {
          if ((loc.timeMs >= trip.startMs && loc.timeMs <= trip.endMs)) {
            const position = {
              lat: Number(loc.lat),
              lng: Number(loc.lng),
            };

            if (loc.headingDegrees != 0)
              tmp_markers.push({position: position, timeMs: loc.timeMs, title: loc.name, icon: this.arrowSymbol(loc, 1.0)});
            else
              tmp_markers.push({position: position, timeMs: loc.timeMs, title: loc.name, icon: this.mapSymbol(loc, 0.8)});
            cnt += 1;
          }
        }

        this.markers = tmp_markers;

        this.fit_marker_bounds();

        //add geofences

        if (this.$refs.mapRef) {
          console.log("adding addresses: " + this.addresses.length + ":" + this.show_geofence_names)
          for (const address of this.addresses) {

            if (address.lat && this.show_geofence_names)
              this.markers.push({
                position: {lat: Number(address.lat), lng: Number(address.lng)},
                icon: this.pointSymbol(),
                label: {text: address.name.substring(0, 30), className: 'geofence-label'},
                isGeofence: true,
                geofenceName: address.name.substring(0, 30)
              });

            if (address.type.indexOf('circle') != -1) {

              const cityCircle = new google.maps.Circle({
                strokeColor: "#458FE5",
                strokeOpacity: 0.8,
                strokeWeight: 2,
                fillColor: address.color,
                fillOpacity: 0.1,
                map: this.$refs.mapRef.$mapObject,
                center: {lat: address.lat, lng: address.lng},
                radius: address.radius,
              });
            } else {
              const shape = new google.maps.Polygon({
                paths: address.vertices,
                strokeColor: "#458FE5",
                strokeOpacity: 0.8,
                strokeWeight: 2,
                fillColor: address.color,
                fillOpacity: 0.1,
                map: this.$refs.mapRef.$mapObject,
              });
            }

          }

          // Apply zoom-based label visibility for the current zoom level
          this.updateGeofenceLabelVisibility(this.$refs.mapRef.$mapObject.getZoom());
        }


      } else {
        this.markers = this.markers_full;
        this.fit_marker_bounds();
      }

    },
    fit_marker_bounds() {
      if (this.$refs.mapRef) {

        let bounds = new google.maps.LatLngBounds();
        for (const loc of this.markers) {
          bounds.extend(loc.position);
        }

        this.$refs.mapRef.$mapObject.fitBounds(bounds, 100);
      }
    },
    // Geofence labels overlap badly when zoomed out; only show them at zoom >= threshold
    updateGeofenceLabelVisibility(zoom) {
      const LABEL_ZOOM_THRESHOLD = 8;
      this.markers = this.markers.map(marker => {
        if (!marker.isGeofence) return marker;
        return {
          ...marker,
          label: zoom >= LABEL_ZOOM_THRESHOLD
            ? {text: marker.geofenceName, className: 'geofence-label'}
            : undefined
        };
      });
    },
    async load_vehicles() {
      this.vehicle_options = []
      try {
        const {value: {data = []}} = await get_vehicle_list(this.user.tenant, moment(this.details_fromDate, 'MM-DD-YYYY').format('YYYY-MM-DD'))
        this.vehicle_options = data.filter(item => item['text'] !== 'All')
      } catch(e) {
        this.$emit('showAlert', 'error loading data, try logging in again or contact support if needed', 'danger', 5000)
      }
    },
    async load_data() {
      this.loading = true
      try {
        this.markers = []
        let results = null;
        if (this.user.types[this.user.tenant].indexOf('TBN') != -1)
          results = await get_tbn_vehicle_trip_history(this.user.tenant, this.vehicle_id, moment(this.details_fromDate, 'MM-DD-YYYY').format('YYYY-MM-DD'))
        else
          results = await get_vehicle_trip_history(this.user.tenant, this.vehicle_id, moment(this.details_fromDate, 'MM-DD-YYYY').format('YYYY-MM-DD'))

        const {value: { data = [] } } = results
        this.summary = data.summary
        moment.tz.setDefault(this.summary.timezone)
        this.items = data.results
        this.trips = data.trips
        this.addresses = data.addresses
        this.zoom = this.summary.zoom
        let cnt = 0;
        let mod = Math.round(this.items.length / 500)
        if (this.items && this.items.length > 0) {
          for (const loc of this.items) {
            const position = {
              lat: Number(loc.lat),
              lng: Number(loc.lng),
            };

            if (this.items.length < 500 || cnt % mod === 0 || loc.speedMilesPerHour === 0)
              this.markers.push({position: position, timeMs: loc.timeMs, title: loc.name, icon: this.mapSymbol(loc, 1.0)});
            cnt += 1;
          }
        }
        else {
          this.loading = false;
          return;
        }

        this.center = this.markers[Math.round(this.markers.length / 2)].position;
        this.zoom = 7
        this.markers_full = this.markers;

        // Register zoom listener once per data load; remove any prior listener first
        this.$nextTick(() => {
          if (this.$refs.mapRef && this.$refs.mapRef.$mapObject) {
            if (this._zoomListener) {
              google.maps.event.removeListener(this._zoomListener);
            }
            this._zoomListener = this.$refs.mapRef.$mapObject.addListener('zoom_changed', () => {
              this.updateGeofenceLabelVisibility(this.$refs.mapRef.$mapObject.getZoom());
            });
          }
        });
      } catch(e) {
        this.$emit('showAlert', 'error retrieving data, try logging in again or contact support if needed', 'danger', 5000)
      }

      this.loading = false
    },
    pointSymbol() {
      return {
        path: "M-5,0a5,5 0 1,0 10,0a5,5 0 1,0 -10,0",
        scale: .1,
        strokeColor: "#29C68A",
        fillColor: "#29C68A",
        fillOpacity: .5,
      }
    },
    mapSymbol(loc, scale) {
      return {
        path: "M-5,0a5,5 0 1,0 10,0a5,5 0 1,0 -10,0",
        scale: scale,
        strokeColor: "#29C68A",
        fillColor: loc.speedMilesPerHour == 0 ? "darkred" : "#29C68A",
        fillOpacity: .5,
      }
    },
    arrowSymbol(loc, scale) {
      return {
        path: "M0,0 L-6,14 L0,0 L6,14 L0,10 L-6,14",
        scale: scale,
        strokeColor: "#29C68A",
        fillColor: "#29C68A",
        fillOpacity: .5,
        rotation: Number(loc.headingDegrees)
      }
    },
  },
  computed: {
    ...mapState({
      user: state => state.profile.user
    }),
    google: gmapApi,
    // the light mapStyle in data stays untouched; midnight users get the
    // dark basemap (in-shell map pages only -- standalone maps stay light)
    themed_map_options() {
      const midnight = (this.$store.state.profile || {}).site_theme === 'midnight'
      return midnight ? { ...this.mapStyle, styles: DARK_MAP_STYLES } : this.mapStyle
    },
  },
  watch: {
    user: {
      deep: true,
      handler() {
        this.check_features()
      }
    },
    show_geofence_names () {
      if (this.selected_trip) {
        this.selected_trip['selected'] = false;
        this.toggle_trip(this.selected_trip);
      }
    }
  }
}
</script>
<style>

.trip-item:hover {
  background-color: #F6F7F9;
}

.geofence-label {
  opacity: 0.85;
  font-size: 11px;
  bottom: -20px;
  position: relative;
  border: 1px solid #3a7d44;
  background-color: rgba(41, 198, 138, 0.85);
  color: white !important;
  border-radius: 3px;
  padding: 1px 4px;
  white-space: nowrap;
  pointer-events: none;
}

</style>
<style scoped>
/* filter bar geometry (mobile-friendly wrap). the block above stays global
   on purpose (the map label classes leak into gmap overlays); these are new
   and scoped. */
.map-controls {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  gap: 8px 18px;
  margin-top: 20px;
  font-size: 18px;
  font-weight: bold;
}
.mc-group {
  display: inline-flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 6px;
  min-width: 0;
}
.mc-datepicker { font-size: 20px; font-weight: bold; width: 140px; }
.mc-select { font-size: 20px; font-weight: bold; }
.mc-select--vehicle { width: 200px; }
@media (max-width: 640px) {
  .map-controls { justify-content: flex-start; font-size: 15px; gap: 6px 14px; }
  /* 16px floor keeps ios safari from zooming the viewport on focus */
  .mc-datepicker, .mc-select { font-size: 16px; }
  .mc-select { max-width: 100%; }
}
</style>
